import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { iconMap } from './IconMap';
import type { IconComponentType, IconVariants } from './IconMap';

const StyledIconWrapper = styled(Box)<{ testId?: string }>(
  (props) => `
 data-testid: ${props.testId};
`,
);

const fontSizeMap: Record<
  'normal' | 'medium' | 'large' | 'inherit',
  SvgIconProps['fontSize']
> = {
  normal: 'small',
  medium: 'medium',
  large: 'large',
  inherit: 'inherit',
};

type IconRendererProps = {
  testId?: string;
  size?: 'normal' | 'medium' | 'large' | 'inherit';
  name: IconVariants;
} & IconComponentType;

const IconRenderer: React.FC<IconRendererProps> = ({
  testId,
  size = 'normal',
  name,
  ...props
}) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <StyledIconWrapper testId={testId}>
      <IconComponent
        fontSize={fontSizeMap[size]}
        {...props}
      />
    </StyledIconWrapper>
  );
};

export default IconRenderer;
